import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: React.ReactNode;
  content: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
  variant?: 'dark' | 'golden' | 'cream';
}
export function AccordionItem({
  title,
  content,
  isOpen,
  onClick,
  variant = 'dark'
}: AccordionItemProps) {
  const baseClasses = 'rounded-xl overflow-hidden mb-3 border transition-colors';
  const variantClasses = {
    dark: 'bg-[#24180d] border-white/10 text-white',
    golden: 'bg-white border-yellow-200 text-fondo-principal shadow-sm',
    cream: 'bg-white border-orange-100 text-fondo-principal shadow-sm'
  };
  return <div className={`${baseClasses} ${variantClasses[variant]}`} data-id="element-15">
      <button onClick={onClick} aria-expanded={isOpen} className="w-full flex items-center justify-between p-4 text-left focus:outline-none" data-id="element-16">
        <div className="flex-1 pr-4" data-id="element-17">{title}</div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="shrink-0" data-id="element-18">
          <ChevronDown className="w-5 h-5 opacity-70" data-id="element-19" />
        </motion.div>
      </button>

      <AnimatePresence initial={false} data-id="element-20">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-21">
            <div className="p-4 pt-0 border-t border-current/10 mt-2" data-id="element-22">
              {content}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}